var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.771875 9.90938L0.8375 9.85312L5.72812 5.60312C5.89375 5.45937 5.99687 5.24375 5.99687 5.00313C5.99687 4.7625 5.89062 4.54687 5.72812 4.40312L0.846875 0.15625L0.765625 0.0843749C0.6875 0.0312499 0.59375 0 0.49375 0C0.221875 0 0 0.23125 0 0.51875V9.48125C0 9.76875 0.221875 10 0.49375 10C0.596875 10 0.69375 9.96563 0.771875 9.90938Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHide);
export default __webpack_public_path__ + "static/media/arrow-hide.018d34277ad2c983932e812dac36be68.svg";
export { ForwardRef as ReactComponent };